import { useMutation, useQueryClient } from '@tanstack/react-query';
import { userApi } from '../api/userApi';
import type { ChangeRoleRequest } from '../types/user';

/**
 * PATCH /api/eraf/users/{id}/role — 역할 변경
 * 성공 시 상세/목록 쿼리 무효화
 */
export function useChangeUserRole(id: number) {
  const qc = useQueryClient();

  return useMutation({
    mutationFn: (body: ChangeRoleRequest) => userApi.changeRole(id, body),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['user-management', 'detail', id] });
      void qc.invalidateQueries({ queryKey: ['user-management', 'list'] });
    },
  });
}
